<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    persistent
    v-if="hasEdit('customers')"
  >
    <template v-slot:activator="{ on }">
      <v-btn height="40px" class="mr-3" depressed color="success" v-on="on"
        >Charge Client
      </v-btn>
    </template>
    <dialog-card
      :title="title"
      @submit="handleSubmit"
      @close="dialog = false"
      :loading="loading"
      ref="dialog"
    >
      <running-totals v-if="dialog" :isPage="false" />

      <v-row>
        <v-col cols="12" class="py-0 d-flex align-center">
          <div class="flex-1">
            <select-field
              v-model="formData.payment_method_id"
              :items="clientPaymentMethods"
              :rules="'required'"
              @input="onPaymentMethodChange"
              :loading="isLoading"
              label="Payment Method"
              :menu-props="{ offsetY: true }"
            >
              <template v-slot:item="data">
                <v-list-item-action class="mr-3 my-2">
                  <img
                    :src="getLogo(data.item)"
                    style="object-fit: contain"
                    height="30px"
                    width="30px"
                    alt="Logo"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.name"
                  ></v-list-item-title>
                </v-list-item-content>
              </template>
            </select-field>
          </div>
          <div class="ml-3" style="width: 120px">
            <add-client-payment-method-dialog
              @onPaymentMethod="fetchPaymentMethods()"
            />
          </div>
        </v-col>

        <v-col cols="12" md="3" class="py-0">
          <input-field
            v-model="formData.amount"
            :rules="'required|decimal'"
            label="Amount"
            prefix="$"
          ></input-field>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <select-field
            v-model="formData.type"
            :rules="'required'"
            :items="types"
            label="Type"
          ></select-field>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <date-field
            v-model="formData.transaction_date"
            :rules="'required'"
            :readonly="isCreditCard"
            :max="maxDate"
            label="Transaction Date"
          />
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <time-field
            v-model="formData.transaction_time"
            :rules="'required'"
            :readonly="isCreditCard"
            label="Transaction Time"
          />
        </v-col>
      </v-row>
    </dialog-card>
  </v-dialog>
</template>

<script>
import DialogCard from "@/components/ui/DialogCard.vue";
import SelectField from "@/components/ui/form/SelectField.vue";
import InputField from "@/components/ui/form/InputField.vue";
import {mapDocs, sortAlpha} from "@/assets/utils/doc.utils";
import {collection, getDocs, orderBy, query, where} from "firebase/firestore";
import {clientPaymentTypes} from "@/assets/constants/client.constants";
import {colClients, functions} from "@/assets/utils/firebase.utils";
import DateField from "@/components/ui/form/DateField.vue";
import {httpsCallable} from "firebase/functions";
import moment from "moment-timezone";
import RunningTotals from "@/pages/mycompany/RunningTotals.vue";
import AddClientPaymentMethodDialog from "./AddClientPaymentMethodDialog.vue";
import TimeField from "@/components/ui/form/TimeField.vue";

export default {
  components: {
    TimeField,
    DialogCard,
    SelectField,
    InputField,
    DateField,
    RunningTotals,
    AddClientPaymentMethodDialog,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      title: "Charge Client",
      isLoading: true,
      formData: {
        payment_method_id: "",
        amount: "",
        transaction_date: "",
        type: "",
        portalType: "",
        transaction_time: "",
      },
      maxDate: moment().format("YYYY-MM-DD"),
      ccPaymentMethods: [],
    };
  },
  computed: {
    clientPaymentMethods() {
      let paymentMethods = this.$store.getters.clientPaymentMethods;
      return [...this.ccPaymentMethods, ...sortAlpha([...paymentMethods])];
    },
    isBoth() {
      return this.currentClient.client_type === "Both";
    },
    types() {
      return ["Sale", "Refund"];
    },
    isCreditCard() {
      let paymentMethod = this.clientPaymentMethods.find(
        (i) => i.value === this.formData.payment_method_id
      );
      return paymentMethod != null && paymentMethod.type === "cc";
    },
  },
  watch: {
    dialog(val) {
      this.formData.transaction_date = "";
      this.$nextTick(() => {
        this.$refs.dialog.reset();
        if (val) {
          this.formData = {
            payment_method_id: "",
            amount: "",
            transaction_date: moment().format("YYYY-MM-DD"),
            transaction_time: moment().format("HH:mm"),
            type: "",
          };
          console.log(this.formData);
          this.fetchPaymentMethods();
        }
      });
    },
  },
  methods: {
    getLogo(item) {
      if (item.payment_method === "Credit Card") {
        let title = (item.name || "").toString().toLowerCase();
        if (title.includes("visa"))
          return require("@/assets/images/card/visa.svg");
        if (title.includes("amex"))
          return require("@/assets/images/card/amex.svg");
        if (title.includes("jcb"))
          return require("@/assets/images/card/jcb.svg");
        if (title.includes("amex"))
          return require("@/assets/images/card/amex.svg");
        if (title.includes("mastercard"))
          return require("@/assets/images/card/mastercard.png");
        if (title.includes("discover"))
          return require("@/assets/images/card/discover.svg");
        if (title.includes("diners"))
          return require("@/assets/images/card/diners.svg");
      } else {
        if (item.name_lw === "auth.net") {
          return require("@/assets/images/auth-net.png");
        }
        if (item.name_lw === "paypal") {
          return require("@/assets/images/paypal.png");
        }
        if (item.name_lw === "cash") {
          return require("@/assets/images/cash.png");
        }
        if (item.name_lw === "zelle") {
          return require("@/assets/images/zelle.png");
        }
        if (item.name_lw === "cash app") {
          return require("@/assets/images/cashapp.png");
        }
        if (item.name_lw === "apple pay") {
          return require("@/assets/images/apple-pay.png");
        }
        if (item.name_lw === "venmo") {
          return require("@/assets/images/venmo.png");
        }
      }
      return item.logo || require("@/assets/images/credit-card.png");
    },
    onPaymentMethodChange() {
      if (this.isCreditCard) {
        this.formData.transaction_date = moment().format("YYYY-MM-DD");
        this.formData.transaction_time = moment().format("HH:mm");
      }
    },
    async handleSubmit() {
      try {
        this.loading = true;
        let chargeClient = httpsCallable(
          functions,
          "insertManualPaymentAction"
        );
        const date = `${this.formData.transaction_date} ${this.formData.transaction_time}`;
        await chargeClient({
          ...this.formData,
          transaction_date: moment(date, "YYYY-MM-DD HH:mm").format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          payment_type: this.isCreditCard ? "cc" : "mpm",
          customer_id: this.$route.params.id,
        });
        this.notifySuccess("Transaction successful.");
        this.dialog = false;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async fetchPaymentMethods() {
      try {
        this.isLoading = true;
        let col = collection(
          colClients,
          this.$route.params.id,
          "payment_methods"
        );
        let listQuery = query(
          col,
          where("payment_method", "==", "Credit Card"),
          orderBy("created_at", "desc")
        );
        const list = mapDocs((await getDocs(listQuery)).docs).map((i) => {
          let paymentMethod = clientPaymentTypes.find(
            (p) => p.value === i.payment_method
          );
          if (paymentMethod) {
            i.name = `${i.payment_method}: ${i[paymentMethod.title]}`;
          }
          return { ...i, value: i.id, type: "cc" };
        });
        const primaryCard = list.find((i) => i.is_primary);
        if (primaryCard) {
          this.ccPaymentMethods = [primaryCard];
        } else {
          this.ccPaymentMethods = list.filter((i) => !i.is_primary);
        }
        this.isLoading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>
